/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidatorRuntime
 */
export interface ValidatorRuntime {
    /**
     * 
     * @type {string}
     * @memberof ValidatorRuntime
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ValidatorRuntime
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof ValidatorRuntime
     */
    online: boolean;
}

export function ValidatorRuntimeFromJSON(json: any): ValidatorRuntime {
    return ValidatorRuntimeFromJSONTyped(json, false);
}

export function ValidatorRuntimeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidatorRuntime {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'online': json['online'],
    };
}

export function ValidatorRuntimeToJSON(value?: ValidatorRuntime | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'online': value.online,
    };
}


